<template>
  <div class="big-box">
    <div class="scroll-box">
      <img :src="backgroundImage" alt="" class="big-box-img" />
      <div class="big-body">
        <img :src="tapTopUrl" alt="" class="tap-top" />
        <div class="pd8">
          <!-- 主题文字 -->
          <div
            class="theme-word"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <div v-if="customerPaperwork.title">
              {{ customerPaperwork.title }}
            </div>
            <div v-else></div>
            <div v-if="customerPaperwork.desc">
              {{ customerPaperwork.desc }}
            </div>
            <div v-else></div>
          </div>
          <!-- 分享图区域 -->
          <div class="share-box">
            <!-- 图片轮播区域 -->
            <div class="carousel-wrapper">
              <!-- 左切换按钮 -->
              <div
                class="carousel-btn left-btn"
                @click="prevSlide"
                v-if="carouselImages.length > 1"
              >
                <span class="el-icon-arrow-left arrow"></span>
              </div>
              <div
                v-for="(item, index) in carouselImages"
                :key="index"
                class="carousel-item"
                :style="getItemStyle(index)"
              >
                <img :src="item" alt="分享图" class="carousel-img" />
              </div>
              <!-- 右切换按钮 -->
              <div
                class="carousel-btn right-btn"
                @click="nextSlide"
                v-if="carouselImages.length > 1"
              >
                <span class="el-icon-arrow-right arrow"></span>
              </div>
            </div>
            <!-- 底部指示点 -->
            <div class="carousel-indicators">
              <span
                v-for="(_, index) in carouselImages"
                :key="index"
                class="indicator"
                :class="{ active: index === currentIndex }"
                @click="goToSlide(index)"
              ></span>
            </div>

            <!-- 滑动提示 -->
            <div class="slide-hint" v-if="carouselImages.length > 1">
              - - 滑动切换 -
            </div>
            <div class="slide-hint" v-else></div>
            <div
              class="desc-word"
              v-if="carouselImages.length > 1"
              :style="{ color: customerPaperwork.textColor }"
            >
              图文内容为参考示例，您可根据实际情况在小红书自行修改
            </div>
            <div class="desc-word" v-else></div>
            <btnCom
              class="mt10"
              :btnUrl="btnUrl"
              :customerPaperwork="customerPaperwork"
            >
              一键分享小红书
            </btnCom>
            <div class="line-box"></div>
            <div
              class="upload-hint"
              :style="{ color: customerPaperwork.textColor }"
            >
              - 上传小红书笔记链接 -
            </div>
            <div class="input-link">
              小红书笔记链接，在右上角...，复制链接，直接粘贴
            </div>
            <btnCom
              class="mt10"
              :btnUrl="btnUrl"
              :customerPaperwork="customerPaperwork"
            >
              提交链接
            </btnCom>
          </div>
        </div>
        <div class="prize-box">
          <div
            class="prize-title"
            :style="{ color: customerPaperwork.textColor }"
          >
            晒单{{ ruleDTO.activityType == 0 ? "抽" : "领" }}好礼
          </div>
          <div class="prize-list">
            <div
              :class="[
                'prize-content',
                { 'prize-scroll': ruleDTO.activityType == 1 },
              ]"
            >
              <div
                class="prize-item"
                v-for="item in productList"
                :key="item.assetsId"
                :style="{ backgroundColor: customerPaperwork.prizeBgColor }"
              >
                <img
                  class="prize-img"
                  :src="item.logo"
                  alt=""
                  v-if="item.logo"
                />
                <div class="footer-name" v-if="item.title">
                  <div class="prize-name">{{ item.title }}</div>
                  <div class="prize-total" v-if="item.totalAmount > 0">
                    剩余{{ item.totalAmount }}份
                  </div>
                </div>
                <div
                  class="circle-box"
                  @click="selectPrizeFn(item.assetsId)"
                  v-if="ruleDTO.activityType == 1"
                >
                  <img
                    v-if="item.assetsId && item.assetsId === selectPrizeId"
                    src="https://cdn-image.yucrm.cn/b794d2b6fbfb422084b1ca3447e4040e.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <btnCom
            class="mt4"
            :btnUrl="btnUrl"
            :customerPaperwork="customerPaperwork"
          >
            立即{{ ruleDTO.activityType == 0 ? "抽奖" : "领取" }}
          </btnCom>
        </div>
      </div>
    </div>
    <div class="footer-title">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
import btnCom from "./btnCom.vue";
export default {
  name: "",
  components: {
    btnCom,
  },
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    productList: {
      type: Array,
      default: () => [],
    },
    shareContentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectPrizeId: "",
      currentObj: {},
      currentPrize: [],
      currentIndex: 0,
      prizeList: [],
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
      // 备用静态图片数据
      // defaultImages: [
      //   "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg",
      //   "https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg",
      // ],
    };
  },
  computed: {
    tabUrl() {
      return this.customerPaperwork.tabUrl
        ? this.customerPaperwork.tabUrl
        : this.templateObj.url3;
    },
    btnUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
    // 从 shareContentList 数组中提取图片URL，若无则使用默认图片
    carouselImages() {
      if (this.shareContentList && this.shareContentList.length > 0) {
        return this.shareContentList
          .map((item) => item.shareUrl) // 假设每个对象都有 url 字段
          .filter((url) => url); // 过滤掉空URL
      }
      return this.shareContentList;
      // 如果没有传入数据，使用默认图片
      // return this.defaultImages;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    selectPrizeFn(id) {
      this.selectPrizeId = id;
    },
    prevSlide() {
      this.currentIndex =
        this.currentIndex === 0
          ? this.carouselImages.length - 1
          : this.currentIndex - 1;
    },
    nextSlide() {
      this.currentIndex =
        this.currentIndex === this.carouselImages.length - 1
          ? 0
          : this.currentIndex + 1;
    },
    goToSlide(index) {
      this.currentIndex = index;
    },
    getItemStyle(index) {
      const diff = index - this.currentIndex;
      const length = this.carouselImages.length;
      const styles = {
        transform: "",
        opacity: "",
        zIndex: "",
        transformOrigin: "bottom left",
      };

      if (diff === 0) {
        // 当前显示的主图 - 居中显示
        styles.transform = "translateX(0) translateY(0) scale(1) rotate(0deg)";
        styles.opacity = "1";
        styles.zIndex = "10";
      } else if (diff === -1 || diff === length - 1) {
        // 左边的图 - 以左下角往左倾斜
        styles.transform =
          "translateX(0px) translateY(0px) scale(0.9) rotate(-10deg)";
        styles.opacity = "0.85";
        styles.zIndex = "8";
      } else if (diff === 1 || diff === -(length - 1)) {
        // 右边的图 - 以右下角往右倾斜
        styles.transform =
          "translateX(13px) translateY(-18px) scale(0.9) rotate(10deg)";
        styles.opacity = "0.85";
        styles.zIndex = "8";
      } else if (diff === -2 || diff === length - 2) {
        // 更左边的图 - 以左下角往左倾斜
        styles.transform =
          "translateX(1px) translateY(0) scale(0.78) rotate(-20deg)";
        styles.opacity = "0.7";
        styles.zIndex = "6";
      } else if (diff === 2 || diff === -(length - 2)) {
        // 更右边的图 - 以左下角往右倾斜
        styles.transform =
          "translateX(30px) translateY(-35px) scale(0.78) rotate(20deg)";
        styles.opacity = "0.7";
        styles.zIndex = "6";
      } else if (diff === -3 || diff === length - 3) {
        // 左边第三张图 - 以左下角往左倾斜
        styles.transform =
          "translateX(5px) translateY(2px) scale(0.72) rotate(-30deg)";
        styles.opacity = "0.55";
        styles.zIndex = "4";
      } else if (diff === 3 || diff === -(length - 3)) {
        // 右边第三张图 - 以左下角往右倾斜
        styles.transform =
          "translateX(40px) translateY(-45px) scale(0.72) rotate(30deg)";
        styles.opacity = "0.55";
        styles.zIndex = "4";
      } else {
        // 其他图隐藏
        styles.transform = "translateX(0) translateY(20px) scale(0.7)";
        styles.opacity = "0";
        styles.zIndex = "1";
      }

      return styles;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {

  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;
  .scroll-box {
    position: relative;
    width: 284px;
    height: 560px;
    overflow-y: auto;
    overflow-x: hidden;
    // scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    // -ms-overflow-style: none;
    border-radius: 24px;
  }
  .big-box-img {
    border-radius: 24px;
    width: 284px;
    object-fit: cover;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      padding-top: 10px;
      width: 100%;
    }
    .pd8 {
      width: 100%;
      height: 100%;
      margin-top: 22px;
      // padding: 8px;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > div:first-child {
          height: 15px;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > div:last-child {
          height: 11px;
          font-size: 11px;
          line-height: 11px;
        }
      }
      .share-box {
        width: 259px;
        padding: 10px 12px 0;
        // height: 280px;
        margin: 50px auto 0;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        // border: 1px solid #000;
        .carousel-wrapper {
          position: relative;
          width: 100%;
          height: 152px;
          display: flex;
          justify-content: center;
          .carousel-item {
            position: absolute;
            width: 120px;
            height: 152px;
            overflow: hidden;
            box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.1);
            border-radius: 9px 9px 9px 9px;
            border: 2px solid #ffffff;
            transition: all 0.3s ease;
            .carousel-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .carousel-btn {
            position: absolute;
            width: 28px;
            height: 28px;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 100;
            .arrow {
              font-size: 16px;
              color: #ffffff;
            }
          }

          .left-btn {
            left: 0px;
            top: 70%;
          }

          .right-btn {
            right: 0px;
            top: 70%;
          }
        }
        .carousel-indicators {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2px;
          margin-top: 9px;

          .indicator {
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: rgba(26, 26, 26, 0.2);
            cursor: pointer;
            transition: all 0.3s ease;

            &.active {
              background: #1a1a1a;
            }
          }
        }

        .slide-hint {
          font-size: 8px;
          color: #999;
          margin-top: 8px;
          // letter-spacing: 2px;
        }

        .desc-word {
          margin-top: 10px;
          width: 218px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 8px;
          color: #612e14;
          line-height: 8px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .line-box {
          margin: 12px auto;
          width: 238px;
          height: 1px;
          background: rgba(0, 0, 0, 0.1);
        }
        .upload-hint {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #612e14;
          line-height: 12px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .input-link {
          margin-top: 12px;
          padding: 8px;
          width: 100%;
          height: 60px;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 6px;
          border: 1px solid #dcdcdc;

          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #999999;
          line-height: 11px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
    .share-btn {
      position: relative;
      width: 175px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px 50px 50px 50px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50px 50px 50px 50px;
      }
      .share-text {
        color: #8e5014;
        font-size: 12px;
        position: relative;
        z-index: 10;
      }
    }
    .prize-box {
      position: absolute;
      top: 635px;
      width: 268px;
      height: 215px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .prize-title {
        width: 120px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        line-height: 27px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        overflow: hidden;
      }
      .prize-list {
        width: 266px;
        height: 124px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px;
        box-sizing: border-box;
        border-radius: 10px;
        .prize-content {
          display: flex;
          // justify-content: center;
          align-items: center;
          width: 258px;
          overflow: hidden;
          .prize-item {
            position: relative;
            flex-grow: 0;
            flex-shrink: 0;
            margin-right: 4px;
            width: 83px;
            height: 116px;
            padding: 8px;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .prize-img {
              // width: 100%;
              width: 66px;
              height: 66px;
              // object-fit: cover;
              border-radius: 8px 8px 0 0;
            }
            .footer-name {
              padding: 4px;
              width: 66px;
              // height: 20px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;

              background: #ffffff;
              border-radius: 0 0 8px 8px;
              .prize-name {
                font-size: 11px;
                color: #333333;
                line-height: 11px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .prize-total {
                margin-top: 3px;
                font-size: 10px;
                color: #999999;
                line-height: 10px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            // .select-icon {
            //   position: absolute;
            //   top: 6px;
            //   right: 6px;
            //   width: 22px;
            //   height: 22px;
            //   background: rgba(0, 0, 0, 0.35);
            //   border-radius: 50%;
            //   border: 1px solid #ffffff;
            // }
            .circle-box {
              position: absolute;
              top: 6px;
              right: 6px;
              width: 22px;
              height: 22px;
              background: rgba(0, 0, 0, 0.35);
              border-radius: 50%;
              border: 1px solid #ffffff;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 10;
              img {
                width: 15px;
                height: 15px;
              }
            }
            &:first-child {
              margin-left: 1px;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .prize-scroll {
          overflow-x: auto;
          &::-webkit-scrollbar {
            width: 2px;
            height: 2px;
          }
        }
      }
    }
  }
  .footer-title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
  .mt4 {
    margin-top: 4px;
  }
  .mt10 {
    margin-top: 10px;
  }
}
</style>
